import useNewsTipFilterActions from './useNewsTipFilterActions'
export default useNewsTipFilterActions
